export default [
  {
    name: '男',
    value: '1'
  },
  {
    name: '女',
    value: '0'
  }
]



// WEBPACK FOOTER //
// ./src/data/sexs.js